import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getTaiPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.TAI,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  // NOTE(mike): For now, we look for one entity at a time.
  const shipmentPattern = /shipment\/shipment-details\/(\d+)/;
  const shipmentMatch = url.match(shipmentPattern);
  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
}
